module.exports = __webpack_public_path__ + "img/0-lg.a2a8467e.jpg";